import React from "react";
import { AndrichLogo } from "./Logo";
import { Mail, Phone, MapPin } from "lucide-react";

const LINKS = [
  { label: "About Us", href: "#about" },
  { label: "Innovation", href: "#innovation" },
  { label: "Products", href: "#products" },
  { label: "Responsibility", href: "#responsibility" },
  { label: "Contact Us", href: "#contact" },
];

export default function Footer() {
  return (
    <footer className="bg-slate-950 text-slate-300 pt-16 pb-8 px-6 sm:px-10 lg:px-10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="bg-white/95 rounded-2xl px-4 py-3 inline-flex">
            <AndrichLogo />
          </div>
          <p className="mt-5 max-w-md text-sm text-slate-400 leading-relaxed">
            <span className="text-white font-medium">Discovering Light for Life.</span> Innovative
            pharmaceutical solutions delivered with a commitment to quality, ethics, and
            science-driven healthcare across India.
          </p>
        </div>

        <div className="lg:col-span-3">
          <div className="text-[0.7rem] tracking-[0.22em] uppercase text-slate-500 font-medium">Quick Links</div>
          <ul className="mt-4 space-y-2.5">
            {LINKS.map((l) => (
              <li key={l.href}>
                <a href={l.href} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`} className="text-sm text-slate-300 hover:text-green-400 transition-colors">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-4">
          <div className="text-[0.7rem] tracking-[0.22em] uppercase text-slate-500 font-medium">Get In Touch</div>
          <ul className="mt-4 space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <MapPin size={16} className="text-green-400 mt-0.5 shrink-0" />
              <span className="text-slate-300">Andrich Pharmaceuticals Pvt. Ltd., India</span>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={16} className="text-green-400 mt-0.5 shrink-0" />
              <a href="mailto:andrichpharmacueticalpvtltd@gmail.com" className="text-slate-300 hover:text-white break-all">
                andrichpharmacueticalpvtltd@gmail.com
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Phone size={16} className="text-green-400 mt-0.5 shrink-0" />
              <a href="tel:+919598643434" className="text-slate-300 hover:text-white">+91 9598643434</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-slate-500" data-testid="footer-copyright">
          © 2026 Andrich Pharmaceuticals Pvt. Ltd. All Rights Reserved.
        </p>
        <p className="text-xs text-slate-500">
          Crafted with care for a healthier tomorrow.
        </p>
      </div>
    </footer>
  );
}
